import Unset from './Unset'

// This op is officially deprecated
class PullAll extends Unset {

}

export default PullAll
